/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
import {Component} from '@angular/core';

@Component({
    selector: 'app-auth-error',
    templateUrl: './auth-error.component.html',
    styleUrls: ['./auth-error.component.scss'],
    standalone: false
})
export class AuthErrorComponent {
}
